// About.jsx

import React from "react";
import "./Building_Transportation.css";
import { Link } from "react-router-dom";







export default function Building_Transportation() {


  const items = [
    { title: "  העברת מבנים", img: "/images/3.jpeg", path: "/Relocation_of_buildings"},
    { title: "    הרמת מבנים", img: "/images/14.jpeg" , path: "/Lifting_Buildings"},
    { title: "  הובלת קרוואנים", img: "/images/40.jpeg" , path: "/BuildingRehabilitation"},
    { title: "  הובלת מיגונית וממ'ד נייד", img: "/images/41.jpeg", path: "/Transportation_of_protective_equipment_and_mobile_safe_room"},
  
  ];







  return (

    <div className="Building_Transportation-page">
      <div className="Building_Transportation-hero">
        <div className="Building_Transportation-overlay">
          <h1>  הובלת מבנים</h1>
        </div>

<div>
</div>
</div>

    <div className="page2">



       <div className="grid2">
          {items.map((item, index) => (
            
            <Link to={item.path} key={index} className="card2">

              <img src={item.img} alt={item.title} />

              <div className="card2-btn">
                {item.title}
              </div>

            </Link>
        ))}
      </div>
    </div>


      </div>
  );
}


